import { Type } from '@angular/core';
import { MenuEntry } from '@services/menu/entry.schema';

export class BaseMenuEntry extends MenuEntry {
  constructor(view: Type<any>, priority: number) {
    super('document', 'document', view, priority);
  }
}
